import { createFileRoute } from '@tanstack/react-router';

import { StaffLiveReviewView } from 'src/sections/staff/ticket/live-review-view';

export const Route = createFileRoute('/w/tickets/$ticketId/live')({
  component: StaffLiveReviewPage,
});

function StaffLiveReviewPage() {
  const { ticketId } = Route.useParams();
  return <StaffLiveReviewView ticketId={ticketId} />;
}
